export default "__VITE_PUBLIC_ASSET__ae40c0d2__"